const SectionLabel = ({ index, label, dark = false, testId }) => {
  const colorMuted = dark ? "text-white/40" : "text-[#a1a1aa]";
  const colorStrong = dark ? "text-white" : "text-[#090a0f]";
  return (
    <div className="flex items-center gap-4" data-testid={testId}>
      <span className={`font-mono text-[11px] tracking-[0.22em] ${colorMuted}`}>
        {index}
      </span>
      <span className={`h-px w-8 ${dark ? "bg-white/20" : "bg-[#e4e4e7]"}`} />
      <span className={`font-mono text-[11px] tracking-[0.22em] uppercase ${colorStrong}`}>
        {label}
      </span>
    </div>
  );
};

export default SectionLabel;
